const InfoCard = ({ cardTitle, children }) => {
  return (
    <div className='border-1 rounded-md border-secondary-400 bg-gradient-to-br from-secondary-50 to-secondary-100 p-4'>
      <div className='mb-4 text-xl font-medium'>{cardTitle}</div>
      <div>{children}</div>
    </div>
  );
};

export default InfoCard;
